import * as React from 'react';
import { useWaveform } from '@/hooks/useWaveform';
import { formatDuration } from '@/utils/formatters';
import { WaveformView } from '../WaveformView';

interface WaveformPlayerProps {
  url: string | Blob;
  waveColor?: string;
  progressColor?: string;
  height?: number;
  barWidth?: number;
  barGap?: number;
  barRadius?: number;
  className?: string;
  buttonClassName?: string;
  textClassName?: string;
  onFinish?: () => void;
  autoplay?: boolean;
}

export const WaveformPlayer: React.FC<WaveformPlayerProps> = ({
  url,
  waveColor = '#FFFFFF', // default for dark bubbles
  progressColor = '#A4FF66', // accent
  height = 30,
  barWidth = 3,
  barGap = 2,
  barRadius = 3,
  className,
  buttonClassName,
  textClassName,
  onFinish,
  autoplay = false,
}) => {
  const { containerRef, isPlaying, currentTime, duration, togglePlayPause, isReady } = useWaveform({
    url,
    waveColor,
    progressColor,
    height,
    barWidth,
    barGap,
    barRadius,
    cursorWidth: 0, // hide cursor
    onFinish,
    autoplay,
  });

  return (
    <WaveformView
      containerRef={containerRef}
      isPlaying={isPlaying}
      currentTime={formatDuration(currentTime)}
      duration={formatDuration(duration)}
      onTogglePlay={togglePlayPause}
      className={className}
      buttonClassName={buttonClassName}
      textClassName={textClassName}
      disabled={!isReady}
    />
  );
};
